<template>
  <nav id="navbar" class="navbar is-spaced has-shadow is-fixed-top is-solitude-white">
    <div class="container">
      <div class="navbar-brand">
        <a class="navbar-item" :href=links[0].url>
          <img src="../../assets/img/logoFull.svg" :alt=home_alt height="28">
        </a>
      </div>
      <div class="navbar-menu is-active has-background-solitude-white is-shadowless is-pulled-right">
        <div class="navbar-end">
          <div class="navbar-item">
            <a class="button is-outlined is-rounded is-giada-green" :href=links[0].url>Bring me home!</a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'nav-header',
  data: function () {
    return {
      home_alt: 'giada: an intelligent health buddy',
      links: [
        {'name': 'home', 'url': '/'},
        {'name': 'terms', 'url': '/terms'},
        {'name': 'privacy', 'url': '/privacy'}
      ]
    }
  }
}
</script>

<style scoped>
  .navbar .container {
    display: flex;
  }
  .navbar-item {
    display: flex;
    align-items: center;
  }
  .navbar-item {
    display: flex;
  }

  .navbar,
  .navbar-menu,
  .navbar-start,
  .navbar-end {
    align-items: stretch;
    display: flex;
  }

  .navbar-menu{
    flex-grow: 1;
    flex-shrink: 0;
  }

  .navbar-start{
    justify-content: flex-start;
    margin-right: auto;
  }

  .navbar-end{
    justify-content: flex-end;
    margin-left: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/general/NavHeader.vue